import { HunterDescription } from "Components/Onboarding/shared/DocumentsUpload/HunterDescription";
import { MerchantOrCustomerDescription } from "Components/Onboarding/shared/DocumentsUpload/MerchantOrCustomerDescription";
import { StepBox } from "Components/Onboarding/shared/StepBox";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { Resources } from "Translations/Resources";
import { useResource } from "Translations/Resources";
import type { AccessRoleCode } from "Models/AccessRoleCodes";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  onSubmitClick?: () => void;
};

const USER_TYPE_TO_DESCRIPTION: Record<AccessRoleCode, ReactNode> = {
  Hunter: <HunterDescription />, //probably legacy, consider removing
  HunterPlus: <HunterDescription />, //probably legacy, consider removing
  Merchant: <MerchantOrCustomerDescription />,
  Customer: <MerchantOrCustomerDescription />,
  Admin: undefined,
  AdminLite: undefined,
  Aml: undefined,
  Employee: undefined,
  CustomerOnboarding: undefined,
  Disponent: undefined,
  Child: undefined,
};

export const LayoutWithSubmitButton = ({ children, onSubmitClick }: Props) => {
  const { t } = useResource();
  const userRole = useCurrentUserRole();
  const description = userRole && USER_TYPE_TO_DESCRIPTION[userRole];

  return (
    <StepBox
      withDivider
      subTitle={description}
      submitButtonLabel={t(Resources.Common.Continue)}
      onSubmitClick={onSubmitClick}
    >
      {children}
    </StepBox>
  );
};
